import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/routes/index'
import exploreTheWolf from '@/components/routes/explore-the-wolf'
import wolves101 from '@/components/routes/wolves-101'
import packAnatomy from '@/components/routes/pack-anatomy'
import meetTheWolf from '@/components/routes/meet-the-wolf'
import socialBehavior from '@/components/routes/social-behavior'
import benefitsOfWolves from '@/components/routes/the-benefits-of-wolves'
import wolvesAndPeople from '@/components/routes/wolves-and-people'
import landscape from '@/components/routes/landscape'
import about from '@/components/routes/about'
import takeAction from '@/components/routes/take-action'

import siteConfig from './../../static/data/site-config.json'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: route => siteConfig.siteTitle
      }
    },
    {
      path: '/explore-the-wolf',
      name: 'Explore the Wolf',
      component: exploreTheWolf,
      meta: {
        title: route => route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101',
      name: 'wolves-101',
      component: wolves101,
      meta: {
        title: route => route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101/meet-the-wolf',
      name: 'Meet the Wolf',
      component: meetTheWolf,
      meta: {
        title: route => 'wolves-101: ' + route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101/pack-anatomy',
      name: 'Pack Anatomy',
      component: packAnatomy,
      meta: {
        title: route => 'wolves-101: ' + route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101/social-behavior',
      name: 'Social Behavior',
      component: socialBehavior,
      meta: {
        title: route => 'wolves-101: ' + route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101/the-benefits-of-wolves',
      name: 'The Benefits of Wolves',
      component: benefitsOfWolves,
      meta: {
        title: route => 'wolves-101: ' + route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/wolves-101/wolves-and-people',
      name: 'Wolves and People',
      component: wolvesAndPeople,
      meta: {
        title: route => 'wolves-101: ' + route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/ecosystem',
      name: 'Ecosystem',
      component: landscape,
      meta: {
        title: route => route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/about',
      name: 'About',
      component: about,
      meta: {
        title: route => route.name + ' - ' + siteConfig.siteTitle
      }
    },
    {
      path: '/take-action',
      name: 'Take Action',
      component: takeAction,
      meta: {
        title: route => route.name + ' - ' + siteConfig.siteTitle
      }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js